<template>
  <div class="arrangement" v-if="attributes">
    <div v-for="attribute in attributes">
      <div class="option" @click="setOption(attribute.id)"
           :class="{ 'selected' : attribute.id === getOptions.pa_uklad}">
        <img :src="attribute.image"/>
        <span class="name">{{ attribute.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import confirmDialog from "../../../mixins/confirm-dialog"

export default {
  name: "Arrangement",
  props: {
    attributes: {
      type: Array
    }
  },
  mixins: [confirmDialog],
  data () {
    return {
      selectedOption: null
    }
  },
  computed: {
    getOptions() {
      return this.$parent.getOptions
    },
    getStep() {
      return this.$parent.getStep
    },
    getSteps() {
      return this.$parent.getSteps
    }
  },
  watch: {
    checkConfirmationStatus() {
      this.setOptionArrangement(this.selectedOption)
      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
      })
      this.closeConfirmDialog()
    }
  },
  mounted() {
    this.setStep({
      ...this.getSteps.find(step => step.id === this.getStep.id),
      completed: !!this.getOptions.pa_uklad
    })
  },
  updated () {
    if (this.getOptions.pa_uklad) {
      this.setStep({
        ...this.getSteps.find(step => step.id === this.getStep.id),
        completed: !!this.getOptions.pa_uklad
      })
    }
  },
  methods: {
    ...mapActions({
      fetchVariation: 'customizer/fetchVariation'
    }),
    ...mapMutations({
      setStep: 'customizer/setStep',
      setOptionArrangement: 'customizer/setOptionArrangement'
    }),
    setOption (option) {
      this.selectedOption = option
      if (this.compareValues(option, this.getOptions.pa_uklad)) {
        this.openConfirmDialog()
        return
      }
      this.setOptionArrangement(option)
      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
      })
    },

    changeWCVariation() {
      const options = JSON.parse(JSON.stringify(this.getOptions))

      delete options.pa_additionals
      delete options.group

      let form = new FormData()

      Object.keys(options).forEach((item) => {
        if (options[item]) {
          form.append('attribute_' + item, options[item])

          const select = document.querySelector(`select#${item}`)
          if (select) {
            select.value = options[item]
            select.dispatchEvent(new Event("change", {"bubbles": true}))
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.arrangement {
  padding: 25px 15px;
  @media (max-width: 480px) {
    padding: 25px 0;
  }
  .option {
    display: flex;
    align-items: center;
    padding: 15px;
    border: 1px solid #efefef;
    border-radius: 5px;
    margin-bottom: 10px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    color: #3C3C3C;
    transition: all .2s;

    @media (max-width: 480px) {
      font-size: 14px;
    }

    span.name {
      margin: 0 0 0 15px;
    }

    &.selected {
      border: 1px solid #3c3c3c;
    }

    &:hover {
      border: 1px solid #3c3c3c;
    }
  }
}
</style>
